import { NoticesSection } from "./settings/NoticesSection.js";
import { CallRoutesSection } from "./settings/CallRoutesSection.js";
import { HoursSection } from "./settings/HoursSection.js";
import { AddressSection } from "./settings/AddressSection.js";
import { ReceptionistSection } from "./settings/ReceptionistSection.js";
import { VoiceStyleSection } from "./settings/VoiceStyleSection.js";
import { SmsSection } from "./settings/SmsSection.js";
import { WebBookingSection } from "./settings/WebBookingSection.js";
import { DobSection } from "./settings/DobSection.js";
import { ServiceAreaSection } from "./settings/ServiceAreaSection.js";
import { JobsSection } from "./settings/JobsSection.js";
import { TeamSection } from "./settings/TeamSection.js";
import { Knowledge } from "./Knowledge.js";

/**
 * Business settings: everything about the business itself in one place, top to bottom:
 * temporary notes, call routes, business hours, address, receptionist name, voice and manner, text messages, online booking, date of birth check, team member permissions, business knowledge.
 */
export function Settings() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <div>
        <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0, color: "var(--rc-text)" }}>Business settings</h1>
        <p style={{ fontSize: 13, color: "var(--rc-text-muted)", margin: "4px 0 0" }}>
          How your business runs and what the receptionist knows about it.
        </p>
      </div>
      <NoticesSection />
      <CallRoutesSection />
      <HoursSection />
      <AddressSection />
      <ServiceAreaSection />
      <JobsSection />
      <ReceptionistSection />
      <VoiceStyleSection />
      <SmsSection />
      <WebBookingSection />
      <DobSection />
      <TeamSection />
      <Knowledge embedded />
    </div>
  );
}
